<template>
  <div>
    <v-container class="ml-10 pr-10">
      <p class="display-1 mt-7">정품 인증 회원 관리</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        정품 인증을 받은 회원 정보를 확인/관리 할 수 있습니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        인증 회원에게 프로모션등 다양한 혜택을 제공하여 브랜딩 관리를 하시길
        권장합니다.
      </p>

      <ManageAuthMemberSearch ref="searchComponent"></ManageAuthMemberSearch>
      <ManageAuthMemberList ref="listComponent"></ManageAuthMemberList>
    </v-container>
  </div>
</template>

<script>
import ManageAuthMemberSearch from "@/components/authservice/auth_member/ManageAuthMemberSearch.vue";
import ManageAuthMemberList from "@/components/authservice/auth_member/ManageAuthMemberList.vue";

export default {
  data: () => ({}),
  components: {
    ManageAuthMemberSearch,
    ManageAuthMemberList,
  },
};
</script>
